import defaultAttributes from '../defaultAttributes';

const View = [
  'svg',
  defaultAttributes,
  [
    [
      'path',
      { d: 'M5 12s2.545-5 7-5c4.454 0 7 5 7 5s-2.546 5-7 5c-4.455 0-7-5-7-5z' },
    ],
    ['path', { d: 'M12 13a1 1 0 100-2 1 1 0 000 2z' }],
    [
      'path',
      {
        d:
          'M21 8V5a2 2 0 00-2-2H5a2 2 0 00-2 2v3m18 8v3a2 2 0 01-2 2H5a2 2 0 01-2-2v-3',
      },
    ],
  ],
];

export default View;
